export default {
    "Layouts": "Plans" // Agencements Dispositions Compositions 
}